module.exports = __webpack_public_path__ + "static/media/HdM_Logo_Weiss.87c22e0a.svg";